import { type MouseEvent } from "react";
import { useNavigate } from "react-router-dom";

import { childIsSingleIcon, sizeIconElement } from "ui/button/button.helpers";
import { IconButtonRoot } from "ui/icon-button/icon-button.styles";
import { type IconButtonProps } from "ui/button/button.types";

import { BUTTON_GLYPH } from "theme";

import { env } from "env";

export const IconButton = ({
  color = "primary",
  variant = "contained",
  size = "medium",
  to,
  onClick,
  type,
  ref,
  children,
  ...rest
}: IconButtonProps) => {
  const navigate = useNavigate();

  if (env.DEV && !childIsSingleIcon(children)) {
    throw new Error("IconButton must have exactly one valid icon as a child");
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (to) {
      navigate(to);
    }
    onClick?.(event);
  };

  return (
    <IconButtonRoot
      ref={ref}
      type={type ?? "button"}
      color={color}
      variant={variant}
      size={size}
      onClick={handleClick}
      {...rest}>
      {sizeIconElement(children, BUTTON_GLYPH[size])}
    </IconButtonRoot>
  );
};
